import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import type { ReactNode } from "react";

// Vite exposes VITE_-prefixed vars on import.meta.env; the old name was
// process.env.NEXT_PUBLIC_CONVEX_URL.
const url = import.meta.env.VITE_CONVEX_URL;
if (!url) {
  throw new Error(
    "VITE_CONVEX_URL is not set. Run `bun run dev` (which starts `convex dev`) " +
      "or copy .env.example to .env.local.",
  );
}

const convex = new ConvexReactClient(url);

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  return <ConvexAuthProvider client={convex}>{children}</ConvexAuthProvider>;
}
